'use strict'

const crypto = require('browserify-aes')

module.exports = {
  createCipheriv: crypto.createCipheriv,
  createDecipheriv: crypto.createDecipheriv
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libp2p-crypto/src/aes/ciphers-browser.js
// module id = aleP
// module chunks = 0